import { render, staticRenderFns } from "./IconEnviromentEnvelope.vue?vue&type=template&id=95de1b38&scoped=true&lang=pug"
import script from "./IconEnviromentEnvelope.vue?vue&type=script&lang=js"
export * from "./IconEnviromentEnvelope.vue?vue&type=script&lang=js"
import style0 from "./IconEnviromentEnvelope.vue?vue&type=style&index=0&id=95de1b38&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95de1b38",
  null
  
)

export default component.exports